"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraInfo = void 0;
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireWildcard(require("react"));
var _pittaModules = require("@thingsw/pitta-modules");
var _DashcamConnectivity = require("../icons/DashcamConnectivity");
var _Typography = require("./Typography");
var _DashcamInvalid = require("../icons/DashcamInvalid");
var _IconButton = require("./IconButton");
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _WifiOn = require("../icons/WifiOn");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _DashcamParked = require("../icons/DashcamParked");
var _ = require("..");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: function root(props) {
      return _objectSpread(_objectSpread(_objectSpread({
        minHeight: "fit-content",
        display: "flex"
      }, props.more ? {
        cursor: "pointer",
        padding: theme.spacing(0.75, 0.875, 0.75, 1.625),
        "&:hover": {
          backgroundColor: _pittaModules.LightColors.primary["10"]
        }
      } : props.hideIcon || props.dense ? {
        padding: 0
      } : props.gpsMobile ? {
        padding: theme.spacing(0.75, 1.5)
      } : {
        padding: theme.spacing(0.75, 2)
      }), props.hover ? {
        cursor: "pointer",
        "&:hover": {
          backgroundColor: _pittaModules.LightColors.primary["10"]
        }
      } : {}), props.disabled ? {
        cursor: "auto",
        opacity: 0.35,
        "&:hover div": {
          backgroundColor: _pittaModules.LightColors.primary["0"]
        },
        "&:active div": {
          backgroundColor: _pittaModules.LightColors.primary["0"]
        },
        "&:hover": {
          color: _pittaModules.LightColors.primary["3"]
        }
      } : {});
    },
    icon: {
      display: "block"
    },
    lteIcon: {
      display: "block",
      fontSize: 18
    },
    iconSamll: {
      fontSize: 18
    },
    iconActive: {
      fill: _pittaModules.LightColors.primary["7"]
    },
    iconInactive: {
      fill: _pittaModules.LightColors.primary["3"]
    },
    iconDiv: _objectSpread({
      minWidth: 24,
      // marginRight: (props) => (props.more ? 5 : 13),
      display: "flex",
      justifyContent: "center"
    }, theme.direction === "rtl" ? {
      marginLeft: 13
    } : {
      marginRight: 13
    }),
    iconDivMore: _objectSpread({}, theme.direction === "rtl" ? {
      marginLeft: 5
    } : {
      marginRight: 5
    }),
    row: {
      display: "flex",
      alignItems: "center"
    },
    marginB5: {
      marginBottom: 5
    },
    marginB4: {
      marginBottom: 4
    },
    infoDiv: {
      flexGrow: 1
    },
    moreBtn: {
      padding: 0
    },
    event: {
      fill: _pittaModules.LightColors.secondary["11"]
    }
  };
});
var CameraInfo = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var camera = props.camera,
    more = props.more,
    onMore = props.onMore,
    _onClick = props.onClick,
    hideIcon = props.hideIcon,
    newFw = props.newFw,
    gpsMobile = props.gpsMobile,
    disabled = props.disabled,
    style = props.style,
    iconStyle = props.iconStyle,
    connectivityStyle = props.connectivityStyle,
    event = props.event;
  var classes = useStyles(props);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _core.useMediaQuery)(theme.breakpoints.down(956));
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEvent = _useState2[0],
    setIsEvent = _useState2[1];
  (0, _react.useEffect)(function () {
    if (event && _moment.default.utc().diff(event, "s") < 60) {
      var remain = 60 - _moment.default.utc().diff(event, "s");
      setIsEvent(true);
      var timerId = setTimeout(function () {
        setIsEvent(function (o) {
          return !o;
        });
      }, remain * 1000);
      return function () {
        clearTimeout(timerId);
      };
    }
  }, [event]);
  var conectivityMarkup = (0, _react.useMemo)(function () {
    if (camera.active === "on") {
      // if (_.startsWith(camera.model, "DR590X")) {
      //   return <CellularWeak svgClassNames={[classes.icon]} />;
      // } else
      if (camera.communication_identifier === "Cat4") {
        if (camera.sensitivity_level === 0) {
          return /*#__PURE__*/_react.default.createElement(_.CellularStrong, {
            className: (0, _clsx4.default)(classes.lteIcon, connectivityStyle)
          });
        } else if (camera.sensitivity_level === 1) {
          return /*#__PURE__*/_react.default.createElement(_.CellularWeak, {
            className: (0, _clsx4.default)(classes.lteIcon, connectivityStyle)
          });
        }
      } else if (camera.communication_identifier === "Wifi") {
        return /*#__PURE__*/_react.default.createElement(_WifiOn.WifiOn, {
          className: (0, _clsx4.default)(classes.icon, classes.iconActive, connectivityStyle)
        });
      }
    }
  }, [camera.active, camera.communication_identifier, camera.sensitivity_level, classes.icon, classes.iconActive, classes.lteIcon, connectivityStyle]);
  var dashcamIconMarkup = (0, _react.useMemo)(function () {
    if (camera.valid === "invalid") {
      return /*#__PURE__*/_react.default.createElement(_DashcamInvalid.DashcamInvalid, {
        fontSize: "small",
        className: (0, _clsx4.default)(classes.icon, classes.iconInactive)
      });
    } else if (camera.active === "on") {
      if (camera.mode === "1") {
        return /*#__PURE__*/_react.default.createElement(_DashcamParked.DashcamParked, {
          className: (0, _clsx4.default)(classes.iconActive, _defineProperty({}, classes.event, isEvent), iconStyle)
        });
      }
      return /*#__PURE__*/_react.default.createElement(_DashcamConnectivity.DashcamConnectivity, {
        className: (0, _clsx4.default)(classes.icon, classes.iconSamll, classes.iconActive, _defineProperty({}, classes.event, isEvent), iconStyle)
      });
    }
    return /*#__PURE__*/_react.default.createElement(_DashcamConnectivity.DashcamConnectivity, {
      className: (0, _clsx4.default)(classes.icon, classes.iconSamll, _defineProperty({}, classes.event, isEvent), classes.iconInactive)
    });
  }, [camera.active, camera.mode, camera.valid, classes.event, classes.icon, classes.iconActive, classes.iconInactive, classes.iconSamll, iconStyle, isEvent]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: style,
    className: classes.root,
    onClick: function onClick() {
      return !disabled && (_onClick === null || _onClick === void 0 ? void 0 : _onClick(camera));
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.infoDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(classes.row, gpsMobile && camera.active !== "on" && classes.marginB5)
  }, !hideIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(classes.iconDiv, (more || gpsMobile) && classes.iconDivMore)
  }, dashcamIconMarkup), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body",
    htmlColor: _pittaModules.LightColors.primary["1"],
    style: {
      wordBreak: "break-all",
      whiteSpace: "pre-wrap"
    }
  }, camera.dev_name))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(classes.row, gpsMobile && camera.active !== "on" && classes.marginB4)
  }, !hideIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(classes.iconDiv, (more || gpsMobile) && classes.iconDivMore)
  }, conectivityMarkup), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: more ? "Small" : "Caption",
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, camera.model))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "relative"
    }
  }, more && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Tooltip, {
    disableTouchListener: mobile,
    placement: "bottom",
    title: "More"
  }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    ref: ref,
    className: classes.moreBtn,
    onClick: function onClick(e) {
      return onMore === null || onMore === void 0 ? void 0 : onMore(e, camera.psn);
    }
  }, /*#__PURE__*/_react.default.createElement(_MoreVert.default, null))), newFw && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: _pittaModules.LightColors.secondary["11"],
      position: "absolute",
      top: -3,
      right: -3
    }
  }))));
});
exports.CameraInfo = CameraInfo;